<script setup>
import PageSpeedUrlForm from '@frontJs/components/forms/projectManagement/dev/PageSpeedUrlForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            Créer une URL pour le temps de chargement - DEV - Gestion de projet
            - Datakepler
        </title>
    </Head>

    <PageTitle :tenant-name="tenant.name">
        Gestion de projet - DEV - Créer une URL pour le temps de chargement
    </PageTitle>

    <PageSpeedUrlForm :tenant="tenant" />
</template>
